import React from 'react';
import { TabLink } from './TabLink';
import { LiquidatedOvertimeHourModel } from '../../models/liquidateOvertimeHours';

interface Props {
    activeTab: string;
    setSelectedList: (item: LiquidatedOvertimeHourModel[]) => void;
}

export const RenderTabs = ({ activeTab, setSelectedList }: Props) => {
    return (
        <ul className='mb-4 nav nav-border-top nav-justified nav-tabs '>
            <TabLink
                activeTab={activeTab}
                setSelectedList={setSelectedList}
                tabValue='employee'
                label='Por empleado'
            />
            <TabLink
                activeTab={activeTab}
                tabValue='date'
                label='Por fecha'
                setSelectedList={setSelectedList}
            />
            <TabLink
                activeTab={activeTab}
                tabValue='status'
                label='Por estado'
                setSelectedList={setSelectedList}
            />
        </ul>
    );
};
